// @flow
import moment from 'moment';
import TimeRange from 'common/domain/TimeRange';

const HOUR_FORMAT = 'HH:mm:ss';

export type SerializedSpotScheduleTimeSlot = {
  fromTime: string;
  toTime: string;
  numberOfSpots: number;
};

class SpotScheduleTimeSlot {

  timeSlot: TimeRange;
  numberOfSpots: number;

  constructor(fromHour: moment, toHour: moment, numberOfSpots: number) {
    this.timeSlot = new TimeRange(fromHour, toHour);
    this.numberOfSpots = numberOfSpots;
  }

  getTimeSlot(): TimeRange {
    return this.timeSlot;
  }

  getFromTime(): moment {
    return this.timeSlot.getStart();
  }

  getToTime(): moment {
    return this.timeSlot.getEnd();
  }

  is(other: SpotScheduleTimeSlot): boolean {
    return other.timeSlot.isSame(this.timeSlot);
  }

  overlaps(other: SpotScheduleTimeSlot): boolean {
    return this.timeSlot.overlaps(other.timeSlot, 'EXCLUSIVE');
  }

  getNumberOfSpots(): number {
    return this.numberOfSpots;
  }

  toObject(): SerializedSpotScheduleTimeSlot {
    return {
      numberOfSpots: this.numberOfSpots,
      fromTime: this.timeSlot.getStart().format(HOUR_FORMAT),
      toTime: this.timeSlot.getEnd().format(HOUR_FORMAT),
    };
  }

  static fromObject(object: SerializedSpotScheduleTimeSlot): SpotScheduleTimeSlot {
    const fromHour = moment(object.fromTime, HOUR_FORMAT);
    const toHour = moment(object.toTime, HOUR_FORMAT);

    return new SpotScheduleTimeSlot(fromHour, toHour, object.numberOfSpots);
  }
}

export default SpotScheduleTimeSlot;



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesInventory/domain/SpotScheduleTimeSlot.js